"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.slideShowProperties = void 0;
var yup = __importStar(require("yup"));
exports.slideShowProperties = yup.object({
    transition: yup
        .mixed()
        .oneOf([
        'NoTransition',
        'SlideVertical',
        'SlideHorizontal',
        'CrossFade',
        'OutIn',
    ])
        .default('SlideHorizontal'),
    autoPlay: yup.bool().default(false),
    autoPlayInterval: yup
        .number()
        .min(0)
        .max(30)
        .default(2),
    direction: yup
        .mixed()
        .oneOf(['LTR', 'RTL'])
        .default('RTL'),
    pauseAutoPlayOnMouseOver: yup.bool().default(false),
    transDuration: yup
        .number()
        .min(0)
        .max(5)
        .default(1),
    shouldHideOverflowContent: yup.bool().default(true),
    flexibleBoxHeight: yup.bool().default(false),
    showNavigationButton: yup.bool().default(true),
    navigationButtonSize: yup
        .number()
        .min(8)
        .max(72)
        .default(21),
    navigationButtonMargin: yup
        .number()
        .min(-72)
        .max(72)
        .default(0),
    showNavigationDots: yup.bool().default(true),
    navigationDotsAlignment: yup
        .mixed()
        .oneOf(['left', 'center', 'right'])
        .default('center'),
    navigationDotsSize: yup
        .number()
        .min(6)
        .max(24)
        .default(6),
    navigationDotsMargin: yup
        .number()
        .min(-50)
        .max(50)
        .default(0),
    navigationDotsGap: yup
        .number()
        .min(0)
        .max(24)
        .default(0),
});
//# sourceMappingURL=SlideShowProperties.schema.js.map